import { render, staticRenderFns } from "./Portion.svg.vue?vue&type=template&id=2fc6336c"
import script from "./Portion.svg.vue?vue&type=script&lang=ts"
export * from "./Portion.svg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fc6336c')) {
      api.createRecord('2fc6336c', component.options)
    } else {
      api.reload('2fc6336c', component.options)
    }
    module.hot.accept("./Portion.svg.vue?vue&type=template&id=2fc6336c", function () {
      api.rerender('2fc6336c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/Portion.svg.vue"
export default component.exports